module.exports = __webpack_public_path__ + "static/img/2.4a8002a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/oem/R410A/2.jpg
// module id = QQOz
// module chunks = 1